import React from 'react';
var UnMemoizedChannelPreviewCountOnly = function (props) {
    var channel = props.channel, displayTitle = props.displayTitle, setActiveChannel = props.setActiveChannel, unread = props.unread, watchers = props.watchers;
    return (React.createElement("div", { className: unread && unread >= 1 ? 'unread' : '' },
        React.createElement("button", { onClick: function () {
                if (setActiveChannel) {
                    setActiveChannel(channel, watchers);
                }
            } },
            ' ',
            displayTitle,
            " ",
            React.createElement("span", null, unread))));
};
/**
 * @deprecated - This UI component will be removed in the next major release.
 */
export var ChannelPreviewCountOnly = React.memo(UnMemoizedChannelPreviewCountOnly);
